const contactData = [
  {
    label: "solene.pettier@gmail.com",
    url: "mailto:solene.pettier@gmail.com",
    icon: "fa-solid fa-envelope fa-xl",
  },
  {
    label: "github.com/solenemep",
    url: "https://github.com/solenemep",
    icon: "fab fa-github fa-xl",
  },
  {
    label: "linkedin.com/in/solenemep",
    url: "https://www.linkedin.com/in/solenemep",
    icon: "fab fa-linkedin fa-xl",
  },
];

export default contactData;
